import { FC, useState } from "react";
import { Content } from "@/layout";
import { Heading, Panel, Text } from "@/ui";
import { OrdersDataProvider } from "./context/OrdersDataContext";
import { Kanban } from "./kanban";
import { OrdersFilters } from "./components/OrdersFilters";
import styles from "./Orders.module.scss";

const Orders: FC = () => {
    const [showKanban, setShowKanban] = useState(() =>
        JSON.parse(localStorage.getItem("show-kanban") ?? "true"),
    );

    const handleToggleView = () => {
        setShowKanban(prev => {
            const next = !prev;
            localStorage.setItem("show-kanban", JSON.stringify(next));
            return next;
        });
    };

    return (
        <Content>
            <OrdersDataProvider pageSize={showKanban ? 50 : 25}>
                <Panel
                    className={styles.root}
                    header={
                        <div className={styles.headerBar}>
                            <div className={styles.headerText}>
                                <Heading level={4}>Orders</Heading>
                                <Text tone="secondary" variant="body-md">
                                    All orders availables in the system
                                </Text>
                            </div>
                        </div>
                    }
                    showHeaderDivider
                >
                    <div className={styles.layout}>
                        <OrdersFilters />
                        <div className={styles.main}>
                            <Kanban
                                onToggleView={handleToggleView}
                                setSearchValue={() => {}}
                                showKanban={showKanban}
                            />
                        </div>
                    </div>
                </Panel>
            </OrdersDataProvider>
        </Content>
    );
};

export default Orders;
